import React from 'react'

import { BrandIconProps } from '../types'
import { SmallSVG } from '../small-svg'

export const TiktokIcon = ({ size, small }: BrandIconProps) => (
  <SmallSVG
    size={size}
    small={small}
    viewBox="0 0 139 120"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="tiktok-logo" fill="#fff" transform="translate(0.000000, 40.000000)" fillRule="nonzero">
        <path
          d="M32.6021004,9.57446809 L32.6021004,9.57446809 C30.630428,9.15460993 28.8857106,8.1248227 27.5750449,6.69219858 C26.2104773,5.20283688 25.3168416,3.27943262 25.1210929,1.15177305 L25.1210929,0.278014184 L23.2373655,0.278014184 L18.2869073,0.278014184 L18.2869073,27.4042553 C18.2755596,30.5673759 15.70813,33.1262411 12.5421063,33.1262411 C10.6754006,33.1262411 9.01862837,32.2382979 7.96896102,30.8595745 L7.96896102,30.8595745 C7.20582449,29.8609929 6.79446837,28.6382979 6.79730531,27.3843972 C6.79730531,24.9929078 8.26116571,22.9446809 10.3434788,22.0794326 L10.3434788,22.0794326 L10.3434788,22.0794326 C11.0215071,21.7985816 11.7619482,21.6425532 12.5421063,21.6425532 C13.1321896,21.6425532 13.7222729,21.7333333 14.2839867,21.9120567 L14.2839867,14.9673759 C13.6258169,14.8765957 12.9619733,14.8397163 12.2952927,14.8539007 L12.2952927,14.8539007 L12.2952927,14.8539007 C5.48380265,14.9957447 0.00283693878,20.5588652 0.00283693878,27.4042553 C0.00283693878,30.8198582 1.36740449,33.9177305 3.58305367,36.1815603 C3.58305367,36.1815603 3.58305367,36.1815603 3.58305367,36.1815603 C3.58305367,36.1815603 3.58305367,36.1815603 3.58305367,36.1815603 L3.58305367,36.1815603 C5.86395245,38.5134752 9.04416082,39.9574468 12.5619649,39.9574468 C19.4982802,39.9574468 25.1210929,34.3375887 25.1210929,27.4042553 L25.1210929,13.5460993 C27.7906522,15.4524823 31.0588057,16.5730496 34.5907945,16.5730496 L34.5907945,9.78156028 C33.9212769,9.78156028 33.2545963,9.71347518 32.6021004,9.57446809 Z"
          id="Path"
        ></path>
        <polygon
          id="Path"
          points="131.747437 22.1191489 138.269559 15.7702128 131.99425 15.7702128 126.822511 20.8964539 126.822511 10.7631206 121.650772 10.7631206 121.650772 32.4964539 126.822511 32.4964539 126.822511 26.8822695 128.422544 25.4156028 133.469459 32.6184397 139.01 32.6184397"
        ></polygon>
        <polygon
          id="Path"
          points="83.3549351 15.7702128 77.0796265 15.7702128 71.9078871 20.8964539 71.9078871 10.7631206 66.7389847 10.7631206 66.7389847 32.4964539 71.9078871 32.4964539 71.9078871 26.8822695 73.5107576 25.4156028 78.5548347 32.6184397 84.0953761 32.6184397 76.8328129 22.1191489"
        ></polygon>
        <polygon
          id="Path"
          points="85.3266076 10.7631206 85.3266076 15.2822695 90.6203353 15.2822695 90.6203353 32.4964539 95.9140631 32.4964539 95.9140631 15.4042553 100.223373 15.4042553 101.698581 10.7631206"
        ></polygon>
        <path
          d="M61.9360473,10.7631206 C60.5090671,10.7631206 59.3515961,11.9120567 59.3515961,13.3276596 C59.3515961,14.7432624 60.5062302,15.8921986 61.9360473,15.8921986 C63.3658645,15.8921986 64.5205038,14.7432624 64.5205038,13.3276596 C64.5233355,11.9120567 63.3658645,10.7631206 61.9360473,10.7631206 Z"
          id="Path"
        ></path>
        <polygon
          id="Path"
          points="41.9952047 15.2822695 47.2889324 15.2822695 47.2889324 32.4964539 52.5826602 32.4964539 52.5826602 15.4042553 56.8919702 15.4042553 58.3671784 10.7631206 41.9952047 10.7631206"
        ></polygon>
        <rect
          id="Rectangle"
          x="59.3544331"
          y="17.7248227"
          width="5.16890245"
          height="14.7744681"
        ></rect>
        <path
          d="M110.093083,28.0794326 C107.676011,28.0794326 105.718523,26.1219858 105.718523,23.7049645 C105.718523,21.2879433 107.676011,19.3304965 110.093083,19.3304965 C112.510155,19.3304965 114.467643,21.2879433 114.467643,23.7049645 C114.461969,26.1191489 112.507318,28.0737589 110.093083,28.0794326 Z M110.093083,14.7120567 C105.125603,14.7120567 101.099987,18.7375887 101.099987,23.7049645 C101.099987,28.6723404 105.125603,32.6978723 110.093083,32.6978723 C115.060563,32.6978723 119.086179,28.6723404 119.086179,23.7049645 C119.086179,21.3191489 118.138641,19.0326241 116.4535,17.3475177 C114.765521,15.6595745 112.478949,14.7120567 110.093083,14.7120567 Z"
          id="Shape"
        ></path>
      </g>
    </g>
  </SmallSVG>
)

TiktokIcon.defaultProps = {
  size: {
    width: 139,
    height: 120,
  },
}
